// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\App\Billing\PendingExportsViewModel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { BillingSystem, BillingSystemData, BillingSystemOptions } from 'data/models/BillingSystem';
import { DispatchEvent, DispatchEventData, DispatchEventOptions } from 'data/models/DispatchEvent';
import { PilotJobOrder, PilotJobOrderData, PilotJobOrderOptions } from 'data/models/PilotJobOrder';

// PendingExportsResponseData is the class that PendingExportsResponse serializes to/from
export interface PendingExportsResponseData {
    Id : number;
	
    BillingSystem : BillingSystemData | null;
    ExportableDispatchEvents : DispatchEventData[] | null;
    ExportablePilotJobOrders : PilotJobOrderData[] | null;
	
}

// PendingExportsResponseOptions is the class which may be passed to the PendingExportsResponse constructor to define optional initial data values
export interface PendingExportsResponseOptions {
    Id : number;
	
    BillingSystem? : BillingSystemOptions | null;
    ExportableDispatchEvents? : DispatchEventOptions[] | null;
    ExportablePilotJobOrders? : PilotJobOrderOptions[] | null;
	
}

export class PendingExportsResponse {
    public Id : DataSignal<number>;
	
    public BillingSystem : DataSignal<BillingSystem | null>;
    public ExportableDispatchEvents : SDataArray<DispatchEvent>;
    public ExportablePilotJobOrders : SDataArray<PilotJobOrder>;
	

    constructor();
    constructor(data : PendingExportsResponseOptions);
    constructor(data: PendingExportsResponseOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.BillingSystem = S.value<BillingSystem | null>(null);
        this.ExportableDispatchEvents = SArray<DispatchEvent>([]);
        this.ExportablePilotJobOrders = SArray<PilotJobOrder>([]);
	    
    }

    static key(obj : PendingExportsResponse) {
        return obj.Id();
    }
    
    static dataKey(obj : PendingExportsResponseOptions) {
        return obj.Id;
    }

    static update(obj : PendingExportsResponse, data : PendingExportsResponseOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PendingExportsResponse.ts